import { Button, LoadIndicator, TextArea } from 'devextreme-react';
import { formatMessage } from 'devextreme/localization';
import React, { useEffect, useCallback } from 'react';
import PopupMVP from '../PopupMVP';

const StornoCommentPopup = ({
  visible,
  onHiding,
  comment,
  setComment,
  onConfirm,
  loading = false,
  okRequest = false,
  modalErrorOpen
}) => {
  useEffect(() => {
    if (okRequest) {
      onHiding();
    }
  }, [okRequest, onHiding]);

  const prepareConfirm = useCallback(() => {
    if (comment && comment.length) {
      onConfirm();
    } else {
      modalErrorOpen({
        message: `${formatMessage('textModal').textStornoInput}`,
        techInfo: '',
        types: 'error',
        title: formatMessage('textError').warning
      });
    }
  }, [comment, modalErrorOpen, onConfirm]);

  return (
    <PopupMVP
      title={formatMessage('textModal').textStornoHeading}
      visible={visible}
      onHiding={onHiding}
    >
      <div className="formData">
        <TextArea
          value={comment}
          placeholder={formatMessage('textModal').textStornoInput}
          stylingMode="outlined"
          onValueChanged={({ value }) => {
            setComment(() => value);
          }}
        />
        <div className="formButton">
          <Button
            type="default"
            stylingMode="contained"
            width={260}
            text="Ок"
            onClick={prepareConfirm}
          >
            <LoadIndicator className="indicator" visible={loading} />
            <span>{formatMessage('textButton').confirm}</span>
          </Button>
          <Button
            text={formatMessage('textButton').cancel}
            type="default"
            stylingMode="text"
            onClick={onHiding}
          />
        </div>
      </div>
    </PopupMVP>
  );
};

export default React.memo(StornoCommentPopup);
